"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerStatusReturnsToJSON = exports.CustomerStatusReturnsFromJSONTyped = exports.CustomerStatusReturnsFromJSON = void 0;
var _1 = require("./");
function CustomerStatusReturnsFromJSON(json) {
    return CustomerStatusReturnsFromJSONTyped(json, false);
}
exports.CustomerStatusReturnsFromJSON = CustomerStatusReturnsFromJSON;
function CustomerStatusReturnsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'subTotal': (0, _1.AmountFromJSON)(json['subTotal']),
        'grandTotal': (0, _1.AmountFromJSON)(json['grandTotal']),
        'items': (json['items'].map(_1.CustomerStatusReturnsItemsFromJSON)),
        'services': (json['services'].map(_1.CustomerStatusReturnsServicesFromJSON)),
        'date': json['date'],
    };
}
exports.CustomerStatusReturnsFromJSONTyped = CustomerStatusReturnsFromJSONTyped;
function CustomerStatusReturnsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'subTotal': (0, _1.AmountToJSON)(value.subTotal),
        'grandTotal': (0, _1.AmountToJSON)(value.grandTotal),
        'items': (value.items.map(_1.CustomerStatusReturnsItemsToJSON)),
        'services': (value.services.map(_1.CustomerStatusReturnsServicesToJSON)),
        'date': value.date,
    };
}
exports.CustomerStatusReturnsToJSON = CustomerStatusReturnsToJSON;
//# sourceMappingURL=CustomerStatusReturns.js.map